<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" style="background-image: url(assets/images/commercial-bg.jpg);">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/history">History of LCCC</a></li>
                            <li><a routerLink="/museum">Museum</a></li>
                            <li><a routerLink="/honours">Honours</a></li>
                            <li><a routerLink="/records">Records</a></li>
                            <li><a routerLink="/ground" class="active">Ground Devlopments</a></li>                                 
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="ground-hero-section cf">
        <div class="container">
            <div class="ground-hero-detail">
                <div class="titel-box">
                    <h2 class="titel-name">Developments at Grace Road</h2>
                </div>
                <div class="ground-hero-developments">
                    <div class="ground-hero-developments-top" >
                        <ul>
                            <li *ngFor="let ground of groundList?.data; let i = index" [ngClass]="{ active: i == 0 }" id="tab-{{i}}"><a href="#" class="year"><span class="ground-years">{{ground?.title}}</span><span class="ground-content">{{ground?.description}}</span></a></li>
                            <!-- <li><a href="#"><span class="ground-years">1889</span><span class="ground-content">Old Pavilion built - presented with Fox Mask of fox named Joey caught on ground during committee  meeting by Fernie Hunt.</span></a></li>
                            <li  class="active"><a href="#"><span class="ground-years">1901</span><span class="ground-content">Ground moved to Aylestone Road.</span></a></li>
                            <li><a href="#"><span class="ground-years">1946</span><span class="ground-content">Return to Grace Road. Bronze Bell returned to Grace Road.</span></a></li>
                            <li><a href="#"><span class="ground-years">1952-1953</span><span class="ground-content">Old Pavilion built - presented with Fox Mask of fox named Joey caught on ground during committee  meeting by Fernie Hunt.</span></a></li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</section><!-- page ends-->